import React, { useEffect, useState } from 'react';
import axios from 'axios';
import "./contactus.scss";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { API_URL } from '../../utils/ApiUrl';
import { Link } from 'react-router-dom';
import Loader from '../../hooks/loader';

const Contactus = () => {

    const [loader, setLoader] = useState(false);

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
    });
    const [errors, setErrors] = useState({});

    const handleClose = () => {
        setShow(false);
        setFormData({
            name: '',
            email: '',
            message: '',
        });
    }
    const handleShow = () => setShow(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const validateForm = () => {
        const { name, email, message } = formData;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let newErrors = {};

        if (!name.trim()) newErrors.name = 'Full name is required.';
        if (!email.trim()) {
            newErrors.email = 'Email is required.';
        } else if (!emailRegex.test(email)) {
            newErrors.email = 'Please enter a valid email address.';
        }
        if (!message.trim()) newErrors.message = 'Please enter your message before submitting the form.';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        setLoader(true);
        
        try {
            const accessToken = localStorage.getItem('accessToken');
            const response = await axios.post(`${API_URL}contact-us`, formData, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            if (response.status === 200) {
                setFormData({ name: '', email: '', message: '' });
                handleShow();
                setLoader(false);
            }
        } catch (error) {
            console.error('Error sending message:', error);
            setErrors({ submit: 'Failed to send message. Please try again.' });
        }
    };

    const isFormFilled = Object.values(formData).some(value => value.trim() !== '');

    return (
        <>
        {
            loader && <Loader />
        }
            <section className='contact'>
                <div className="custom-container">
                    <div className='upperparent'>
                        <div className='left'>
                            <h4 className='upperhead'>Home /<span>Contact us</span> </h4>
                            <h2 className='head'>Contact Us</h2>
                            <p className='para'>Have questions, feedback, or need support? We’d love to hear from you. Feel free to reach out anytime, and we’ll get back to you as soon as possible!</p>
                            <h6 className='mail'>Email us at:<span><a href="mailto: support@tasks.market">support@tasks.market</a></span> </h6>
                            <h6 className='mail'>Follow us on X (Twitter):<span><a href="https://x.com/Tasks_on_Chain" target='_blank'>@Tasks_on_Chain</a></span> </h6>
                        </div>

                        <div className='right'>
                            <div className='mainbox'>
                                <h3 className='mainheading'>Get in Touch</h3>
                                <p className='mainpara'>You can reach us anytime</p>
                                <div className='mainparentinput'>
                                    <div className='innerinput'>
                                        <p>Full Name</p>
                                        <input
                                            className={errors.name ? 'error' : ''}
                                            type='text'
                                            name='name'
                                            placeholder='Enter your full name'
                                            value={formData.name}
                                            onChange={handleInputChange}
                                        />
                                       
                                    </div>
                                    {errors.name && <p className='errortext'>{errors.name}</p>}
                                    <div className='innerinput'>
                                        <p>Email</p>
                                        <input
                                            className={errors.email ? 'error' : ''}
                                            type='text'
                                            name='email'
                                            placeholder='Enter your email address'
                                            value={formData.email}
                                            onChange={handleInputChange}
                                        />
                                       
                                    </div>
                                    {errors.email && <p className='errortext'>{errors.email}</p>}
                                </div>
                                <p className='paratextara'>Message</p>
                                <textarea
                                    className={errors.message ? 'error' : ''}
                                    name='message'
                                    placeholder='Enter your message...'
                                    value={formData.message}
                                    onChange={handleInputChange}
                                />
                                {errors.message && <p className='errortext'>{errors.message}</p>}
                                {errors.submit && <p className='errortext'>{errors.submit}</p>}
                                <button
                                    className={isFormFilled ? 'active' : 'dullbtn'}
                                    onClick={handleSubmit}
                                    disabled={!isFormFilled}
                                >
                                    Send Message
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Modal className='message' show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='content'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none">
                            <rect x="5" y="5.5" width="60" height="60" stroke="#013159" strokeWidth="2" />
                            <rect x="28.2031" y="50.3566" width="2" height="40.2235" transform="rotate(-135 28.2031 50.3566)" fill="#013159" />
                            <rect x="17" y="39.1251" width="2" height="15.43" transform="rotate(-45 17 39.1251)" fill="#013159" />
                        </svg>
                        <h3 className='headingmodal'>Message Sent Successfully</h3>
                        <p className='para'>Thank you for reaching out to us! Your message has been successfully sent, and we’ve received it in our inbox. Our team will review your inquiry and get back to you as soon as possible.</p>
                        <Link to="" onClick={handleClose} className='done text-center'>Done</Link>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Contactus;


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import "./contactus.scss";
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
// import { API_URL } from '../../utils/ApiUrl';
// import { Link } from 'react-router-dom';

// const Contactus = () => {
//     const [show, setShow] = useState(false);
//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         message: '',
//     });
//     const [isFormValid, setIsFormValid] = useState(false);
//     const [error, setError] = useState('');
//     const [showError, setShowError] = useState(false);

//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     const validateForm = () => {
//         const { name, email, message } = formData;
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//         if (!name || !email || !message) {
//             setError('All fields are required.');
//             return false;
//         }

//         if (!emailRegex.test(email)) {
//             setError('Please enter a valid email address.');
//             return false;
//         }

//         setError('');
//         return true;
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//         setShowError(true); // Show error messages once the user starts typing
//     };

//     useEffect(() => {
//         setIsFormValid(validateForm());
//     }, [formData]);

//     const handleSubmit = async () => {
//         if (!validateForm()) return;

//         try {
//             const accessToken = localStorage.getItem('accessToken');
//             const response = await axios.post(`${API_URL}contact-us`, formData, {
//                 headers: { Authorization: `Bearer ${accessToken}` },
//             });

//             if (response.status === 200) {
//                 handleShow();
//             }
//         } catch (error) {
//             console.error('Error sending message:', error);
//             setError('Failed to send message. Please try again.');
//         }
//     };

//     return (
//         <>
//             <section className='contact'>
//                 <div className="custom-container">
//                     <div className='upperparent'>
//                         <div className='left'>
//                             <h4 className='upperhead'>Home /<span>Contact us</span> </h4>

//                             <h2 className='head'>Contact Us</h2>
//                             <p className='para'>Have questions, feedback, or need support? We’d love to hear from you. Feel free to reach out anytime, and we’ll get back to you as soon as possible!</p>
//                             <h6 className='mail'><svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
//                                 <path d="M22.75 5.375H3.25C3.03451 5.375 2.82785 5.4606 2.67548 5.61298C2.5231 5.76535 2.4375 5.97201 2.4375 6.1875V20C2.4375 20.431 2.6087 20.8443 2.91345 21.149C3.2182 21.4538 3.63152 21.625 4.0625 21.625H21.9375C22.3685 21.625 22.7818 21.4538 23.0865 21.149C23.3913 20.8443 23.5625 20.431 23.5625 20V6.1875C23.5625 5.97201 23.4769 5.76535 23.3245 5.61298C23.1722 5.4606 22.9655 5.375 22.75 5.375ZM20.6609 7L13 14.023L5.33914 7H20.6609ZM21.9375 20H4.0625V8.03492L12.4505 15.7242C12.6004 15.8618 12.7965 15.9382 13 15.9382C13.2035 15.9382 13.3996 15.8618 13.5495 15.7242L21.9375 8.03492V20Z" fill="#013159" />
//                             </svg>Email us at:<span><a href="mailto: support@tasks.market">support@tasks.market</a></span> </h6>
//                             <h6 className='mail'><img src='\twitterx.png' alt='img' className='img-fluid' />Follow us on X (Twitter):<span><a href="https://x.com/Tasks_on_Chain" target='_blank'>@Tasks_on_Chain</a></span> </h6>
//                         </div>

//                         <div className='right'>

//                             <div className='mainbox'>
//                                 <h3 className='mainheading'>Get in Touch</h3>
//                                 <p className='mainpara'>You can reach us anytime</p>
//                                 <div className='mainparentinput'>
//                                     <div className='innerinput'>
//                                         <p>Full Name</p>
//                                         <input
//                                             className='error'
//                                             type='text'
//                                             name='name'
//                                             placeholder='Enter your full name'
//                                             value={formData.name}
//                                             onChange={handleInputChange}
//                                         />
//                                         {showError && error && <p className='errortext'>{error}</p>}
//                                     </div>
//                                     <div className='innerinput'>
//                                         <p>Email</p>
//                                         <input
//                                             className='error'
//                                             type='text'
//                                             name='email'
//                                             placeholder='Enter your email address'
//                                             value={formData.email}
//                                             onChange={handleInputChange}
//                                         />
//                                         {showError && error && <p className='errortext'>{error}</p>}
//                                     </div>
                                   
//                                 </div>
//                                 <p className='paratextara'>Mail</p>
//                                 <textarea
//                                 className='error'
//                                     name='message'
//                                     placeholder='Enter your message...'
//                                     value={formData.message}
//                                     onChange={handleInputChange}
//                                 />
//                                 {showError && error && <p className='errortext'>{error}</p>}
//                                 <button
//                                     className={isFormValid ? 'active' : 'dullbtn'}
//                                     onClick={handleSubmit}
//                                     disabled={!isFormValid}
//                                 >
//                                     Send Message
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             <Modal className='message' show={show} onHide={handleClose} centered>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Success</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className='content'>
//                         <svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none">
//                             <rect x="5" y="5.5" width="60" height="60" stroke="#013159" strokeWidth="2" />
//                             <rect x="28.2031" y="50.3566" width="2" height="40.2235" transform="rotate(-135 28.2031 50.3566)" fill="#013159" />
//                             <rect x="17" y="39.1251" width="2" height="15.43" transform="rotate(-45 17 39.1251)" fill="#013159" />
//                         </svg>
//                         <h3 className='headingmodal'>Message Sent Successfully</h3>
//                         <p className='para'>Thank you for reaching out to us! Your message has been successfully sent, and we’ve received it in our inbox. Our team will review your inquiry and get back to you as soon as possible.</p>
//                         <Link to="/" className='done text-center' >Done</Link>
//                     </div>
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

// export default Contactus;
